import Box from "@mui/material/Box";
import { TabelaVirtualizadaGenerica } from "components/TabelaVirtualizadaGenerica/TabelaVirtualizadaGenerica.tsx";
import { colunasEmpresaInicial } from "contexts/ContextConstants.ts";
import { AnimatePresence } from "framer-motion";
import { useRowClick } from "hooks/useRowClick.ts";
import {
    memo,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from "react";
import ToastErro from "../../../../src/components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../src/components/Toast/ToastSucesso/ToastSucesso.tsx";
import { telefoneMask } from "../../../../src/regex/telefoneMask";
import {
    atualizaRegra,
    buscaRegras,
    deletaUser,
    editaUser,
    getUser,
    getUserId,
    resetSenhaUser,
    saveUser,
} from "../../../../src/services/ModuloGerenciador/Usuario";
import CustomButtonV2 from "../../../components/CustomButtonV2/CustomButtonV2.js";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalConfirmacao from "../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalConfirmacao2 from "../../../components/ModalConfirmacao2/ModalConfirmacao2.tsx";
import ModalUsuario from "../../../components/ModalUsuario/ModalUsuario.tsx";
import SelectEmbarqueV2 from "../../../components/SelectEmbarqueV2/SelectEmbarqueV2.js";
import MenusRedux from "../../../contexts/Menus";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import TabelaRedux from "../../../contexts/Tabela";
import CadastroEditHeaderProps from "../../../core/components/CadastroEditHeader.tsx";
import MotionContainer from "../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../core/components/Separator.tsx";
import Layout from "../../../core/layout/Layout.tsx";
import { telefoneValido } from "../../../core/utils/validators.ts";
import { getUsuarioDependencias } from "../../../services/ModuloGerenciador/Geral.ts";
import "../CadastrarUsuario/CadastrarUsuario.css";

const categoriasConhecidas = {
    Viagens: [
        "Toledo",
        "Paranavai",
        "Gloria de Dourados",
        "Rio Verde",
        "Todos",
        "Frota",
        "Template Viagem",
        "Gloria de Dourados 2",
        "Gloria de Dourados 3",
        "T S Clientes",
        "Aguardando CTE",
        "Localizador Veículos",
        "Filiais",
        "Mesorregião",
        "Viagens Deletadas",
        "Viagens Finalizadas Por Motorista",
        "Divergencias SAT",
    ],
    Pedido: ["Pedido", "Gerenciamendo Pedido"],
    Diária: ["Estadia"],
    "Prestação de Serviço": ["Prestação de Serviço"],
    OnTime: ["On Time"],
    "Rotas e Rastreio": ["Rota", "Configurações de Rastreamento"],
    "Gestão de Pessoas": [
        "Clientes",
        "Motorista",
        "Grupo de Clientes",
        "Vincular Clientes",
        "Usuario",
    ],
    "Gestão de Veículos": [
        "Veiculo",
        "Grupo Cargas",
        "Vincular Grupo Cargas",
        "Gerenciamento de Frota",
        "Gerenciamento de Frota Configurações",
        "Documentação",
    ],
    "Dashboards e Configurações": [
        "Dashboard",
        "Estatísticas Terceiros",
        "Faturamento",
        "Configuracoes",
        "Permitir Alterar Frete Fiscal Viagem",
        "Painel",
        "Gerar Login",
        "Enviar Proposta",
        "Classificacao de Pontos",
        "Indicador Faturamento Mensal",
    ],
    Geral: [
        "Uso Comum",
        "Avisos",
        "Cadastrar Cockpit",
        "Cadastrar Meta",
        "Precificação",
        "Cotação",
        "Alerta Geral",
        "Alerta Aprovação",
        "Configuração Diária",
        "Diárias",
    ],
};

const categorias = {
    Viagens: [],
    Pedido: [],
    Diária: [],
    "Prestação de Serviço": [],
    OnTime: [],
    "Rotas e Rastreio": [],
    "Gestão de Pessoas": [],
    "Gestão de Veículos": [],
    "Dashboards e Configurações": [],
    Geral: [],
    Outros: [],
};

function CadastrarUsuario() {
    const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);
    const { profile, hasRegra, tabelaEmpresa, handleLoadData } = useProfile();
    const { menusRedux } = useContext(MenusRedux);

    const [dadosTabela, setDadosTabela] = useState([]);
    const [telaCadastro, setTelaCadastro] = useState(false);
    const [editando, setEditando] = useState(false);
    const [editando2, setEditando2] = useState(false);
    const [open, setOpen] = useState(false);
    const [openUsuario, setOpenUsuario] = useState(false);
    const [openResetSenha, setOpenResetSenha] = useState(false);
    const [semAutorizacao, setSemAutorizacao] = useState(false);
    const [values, setValues] = useState([]);
    const [regras, setRegras] = useState([]);
    const [regrasDoUsuario, setRegrasDoUsuario] = useState([]);
    const [regrasDoUsuarioClone, setRegrasDoUsuarioClone] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openToastSucesso, setOpenToastSucesso] = useState(false);
    const [openToastErro, setOpenToastErro] = useState(false);
    const [textoSucesso, setTextoSucesso] = useState("");
    const [textoErro, setTextoErro] = useState("");
    const [validator, setValidator] = useState({
        telefone: "true",
    });
    const [allSelected, setAllSelected] = useState(false);
    const [userRegras, setUserRegras] = useState([]);
    const [regrasList, setRegrasList] = useState([]);
    const [listaUsuarios, setListaUsuario] = useState([]);
    const [usuarioId, setUsuarioId] = useState();
    const [valuesSelect, setValuesSelect] = useState([]);
    const buscarUsuarios = useCallback(async () => {
        if (!profile?.token) return;
        setLoading(true);
        try {
            const result = await getUser(profile?.token);
            setListaUsuario(result.data);
        } catch (error) {
            setTextoErro(
                typeof error.response?.data === "string"
                    ? error.response?.data
                    : "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
            );
            setOpenToastErro(true);
        }
        setLoading(false);
    }, [profile?.token]);

    useEffect(() => {
        if (!!usuarioId) {
            buscaRegras(usuarioId, profile?.token).then((res) => {
                const regras = [];
                res.data.forEach((element) => {
                    regras.push(element.regras.regra);
                });
                setRegrasDoUsuarioClone(regras);
                formatAndSetRegras(regras);
            });
        }
    }, [usuarioId]);

    const formatList = useCallback((items) => {
        items.forEach((item) => {
            let categoriaEncontrada = false;
            for (const [categoria, regras] of Object.entries(categoriasConhecidas)) {
                if (regras.includes(item.regra)) {
                    categorias[categoria].push(item);
                    categoriaEncontrada = true;
                    break;
                }
            }
            if (!categoriaEncontrada) {
                categorias.Outros.push(item);
            }
        });

        return categorias;
    }, []);

    const handleClose = useCallback(() => setOpen(false), []);
    const handleCloseUsuario = useCallback(() => setOpenUsuario(false), []);
    const handleCloseResetSenha = useCallback(() => setOpenResetSenha(false), []);
    const handleCloseToastSucesso = useCallback(
        () => setOpenToastSucesso(false),
        []
    );
    const handleCloseToastErro = useCallback(() => setOpenToastErro(false), []);

    const handleGoBack = useCallback(() => {
        setTelaCadastro(false);
        setEditando(false);
        setValues([]);
    }, []);

    const formatAndSetRegras = useCallback(
        (userRegras) => {
            const formattedList = formatList(regras);
            const uniqueFormattedList = {};
            for (const [categoria, regrasArr] of Object.entries(formattedList)) {
                const seen = new Set();
                uniqueFormattedList[categoria] = regrasArr.filter((regra) => {
                    if (!seen.has(regra.regra)) {
                        seen.add(regra.regra);
                        return true;
                    }
                    return false;
                });
            }

            const sortedList = Object.entries(uniqueFormattedList)
                .sort((a, b) => b[1].length - a[1].length)
                .reduce((acc, [key, value]) => {
                    acc[key] = value.map((regra) => ({
                        ...regra,
                        check: userRegras.includes(regra.regra),
                    }));
                    return acc;
                }, {});

            setValues((current) => ({ ...current, regras: [] }));
            setUserRegras(userRegras);
            setRegrasList(sortedList);
        },
        [regras]
    );

    useEffect(() => {
        const regrasIdSelecionados = [];

        for (const categoria in regrasList) {
            const lista = regrasList[categoria];

            for (const item of lista) {
                const estaNoClone = regrasDoUsuarioClone.includes(item.regra);
                const jaPossui = regrasDoUsuario.includes(item.regra);

                if (regrasDoUsuarioClone.length > regrasDoUsuario.length) {
                    if (estaNoClone && !jaPossui) {
                        regrasIdSelecionados.push(item.regrasId);
                    }
                }

                if (regrasDoUsuarioClone.length < regrasDoUsuario.length) {
                    if (!estaNoClone && jaPossui) {
                        regrasIdSelecionados.push(item.regrasId);
                    }
                }
            }
        }

        setValues((current) => ({
            ...current,
            regras: regrasIdSelecionados,
        }));
    }, [regrasDoUsuarioClone]);

    const buscarDependencias = useCallback(async () => {
        if (!profile?.token) return;
        setLoading(true);
        try {
            const result = await getUsuarioDependencias(profile?.token);
            setRegras(result.data.regras);
            setDadosTabela(result.data.usuarios);
            setTabelaRedux({});
        } catch (error) {
            setTextoErro(
                typeof error.response?.data === "string"
                    ? error.response?.data
                    : "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
            );
            setOpenToastErro(true);
        }
        setLoading(false);
    }, [profile?.token]);

    useEffect(() => {
        if (profile?.token) {
            setSemAutorizacao(!hasRegra("Usuario"));
            buscarDependencias();
            buscarUsuarios();
        }
    }, [profile?.token]);

    const cadastrar = async () => {
        if (!telefoneValido(values.telefone)) {
            setValidator((current) => ({ ...current, telefone: "false" }));
            return;
        }
        setLoading(true);

        values.regras.splice(0, 1);
        await saveUser(values, profile?.token)
            .then((result) => {
                if (result.status === 200) {
                    setTextoSucesso("Sucesso ao Cadastrar o Usuário!");
                    setOpenToastSucesso(true);
                    setTelaCadastro(false);
                    setValues([]);
                } else {
                    setTextoErro("Erro ao Cadastrar o Usuário!");
                    setOpenToastErro(true);
                }
            })
            .catch((error) => {
                setTextoErro(
                    typeof error.response?.data === "string"
                        ? error.response?.data
                        : "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
                );
                setOpenToastErro(true);
            });
        setLoading(false);
    };

    const title = useMemo(() => {
        if (editando) return "Dados Usuário";
        if (telaCadastro) return "Cadastro Usuário";
        return "Usuários";
    }, [editando, telaCadastro]);

    const editar = async () => {
        let newBody = {
            idUsuario: values.idUsuario,
            usuario: values.usuario,
            senha: "",
            email: values.email,
            telefone: values.telefone,
            nascimento: values.nascimento,
            data: values.data,
            deletado: false,
            cargo: values.cargo
        };

        if (!telefoneValido(values.telefone)) {
            setValidator((current) => ({ ...current, telefone: "false" }));
            setOpenToastErro(true);
            setTextoErro("Telefone invalido.");
            return;
        }

        const regrasId = values.regras;
        setLoading(true);

        await editaUser(newBody, profile?.token)
            .then((result) => {
                if (result.status === 200) {
                    atualizaRegra(regrasId, newBody.idUsuario, profile?.token)
                        .then((resultado) => {
                            if (resultado.status === 200) {
                                setTabelaRedux({});
                                setTextoSucesso("Editado Com Sucesso");
                                handleLoadData();
                                setOpenToastSucesso(true);
                                setTelaCadastro(false);
                                setEditando(false);
                                setValues([]);
                            }
                        })
                        .catch((error) => {
                            setTextoErro(
                                typeof error.response?.data === "string"
                                    ? error.response?.data
                                    : "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
                            );
                            setOpenToastErro(true);
                        });
                }
            })
            .catch((error) => {
                setTextoErro(
                    typeof error.response?.data === "string"
                        ? error.response?.data
                        : "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
                );
                setOpenToastErro(true);
            });
        setLoading(false);
    };

    const buscarUsuarioPorId = async () => {
        setLoading(true);
        await getUserId(tabelaRedux.colunaSelecionada, profile?.token)
            .then((result) => {
                if (result.status === 200) {
                    if (editando) {
                        var todayEm = new Date(result.data.nascimento);
                        var ddPrEn = String(todayEm.getDate()).padStart(2, "0");
                        var mmPrEn = String(todayEm.getMonth() + 1).padStart(2, "0");
                        var yyyyPrEn = todayEm.getFullYear();
                        todayEm = yyyyPrEn + "-" + mmPrEn + "-" + ddPrEn;
                        setValues(result.data);
                        setValues((current) => ({ ...current, nascimento: todayEm }));
                        setRegrasDoUsuario(result.data.regras);
                        formatAndSetRegras(result.data.regras);
                        setLoading(false);
                    }
                }
            })
            .catch((error) => {
                if (!editando) {
                    setTextoErro(
                        typeof error.response?.data === "string"
                            ? error.response?.data
                            : "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
                    );
                    setOpenToastErro(true);
                }
            });
        setLoading(false);
    };

    const deletarEmbarcadorPorId = async () => {
        setLoading(true);
        await deletaUser(tabelaRedux.colunaSelecionada, profile?.token)
            .then((result) => {
                if (result.status === 200) {
                    setTabelaRedux({});
                    setOpenToastSucesso(true);
                }
            })
            .catch((error) => {
                setTextoErro(
                    typeof error.response?.data === "string"
                        ? error.response?.data
                        : "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
                );
                setOpenToastErro(true);
            });
        setLoading(false);
    };

    const resataSenha = async () => {
        setLoading(true);
        await resetSenhaUser(tabelaRedux.colunaSelecionada, profile?.token)
            .then((result) => {
                if (result.status === 200) {
                    setTabelaRedux({});
                    setOpenToastSucesso(true);
                    setTextoSucesso("Senha Redefinida com Sucesso!");
                }
            })
            .catch((error) => {
                setTextoErro(
                    typeof error.response?.data === "string"
                        ? error.response?.data
                        : "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
                );
                setOpenToastErro(true);
            });
        setLoading(false);
    };

    useEffect(() => {
        if (editando) {
            buscarUsuarioPorId();
        } else {
            setValues((current) => ({ ...current, regras: [] }));
            buscarDependencias();
        }
    }, [editando]);

    const memoizedMenus = useMemo(
        () => JSON.stringify(menusRedux).replace(/"/g, `'`),
        [menusRedux]
    );

    const handleChangePhone = useCallback((e) => {
        if (e.target.value.length > 14) return;
        setValues((current) => ({
            ...current,
            telefone: telefoneMask(e.target.value),
        }));
        setValidator((current) => ({
            ...current,
            telefone: "true",
        }));
    }, []);

    const handleCheckboxChange = (dado, e) => {
        setValues((current) => {
            const updatedRegras = values.regras.includes(dado.regrasId)
                ? values.regras.filter((id) => id !== dado.regrasId)
                : [...values.regras, dado.regrasId];
            return { ...current, regras: updatedRegras };
        });
        setRegrasList((current) => {
            const updatedList = { ...current };
            Object.keys(updatedList).forEach((key) => {
                updatedList[key] = updatedList[key].map((regra) =>
                    regra.regrasId === dado.regrasId
                        ? { ...regra, check: e.target.checked }
                        : regra
                );
            });
            return updatedList;
        });
    };

    const handleSelectAllChange = useCallback(
        (e) => {
            setAllSelected(e.target.checked);
            const allRegras = Object.values(regrasList).flat();
            if (e.target.checked) {
                const updatedRegrasId = allRegras
                    .filter((regra) => !userRegras.includes(regra.regra))
                    .map((regra) => regra.regrasId);
                setValues((current) => ({
                    ...current,
                    regras: updatedRegrasId,
                }));
            } else {
                const updatedRegrasId = allRegras
                    .filter((regra) => userRegras.includes(regra.regra))
                    .map((regra) => regra.regrasId);
                setValues((current) => ({
                    ...current,
                    regras: updatedRegrasId,
                }));
            }

            setRegrasList((current) => {
                const updatedList = { ...current };
                Object.keys(updatedList).forEach((key) => {
                    updatedList[key] = updatedList[key].map((regra) => ({
                        ...regra,
                        check: e.target.checked,
                    }));
                });
                return updatedList;
            });
        },
        [regrasList, values.regras, userRegras]
    );
    
        const handleSingleClick = useCallback(
            (row) => {
                if (!row) return;
                setTabelaRedux({
                    colunaSelecionada: row.idUsuario,
                    usuarioAlteracao: row.usuario || row.usuarioAlteracao || null,
                    dataAlteracao: row.data || row.dataAlteracao || null,
                    row,
                });
            },
            [setTabelaRedux]
        );
    
        const handleDoubleClick = useCallback(() => {
            setTelaCadastro(true);
            setEditando(true);
        }, [setEditando, setTelaCadastro]);
    
        const handleRowClick = useRowClick({
            idKey: "idUsuario",
            onSelect: handleSingleClick,
            onDouble: handleDoubleClick,
        });
    
        const getRowClassName = useCallback(
            (row) => {
                if (!tabelaRedux?.colunaSelecionada) return "";
                return row.idUsuario === tabelaRedux.colunaSelecionada
                    ? "selecionado"
                    : "";
            },
            [tabelaRedux?.colunaSelecionada]
        );

    const detalhesUsuarioString = useMemo(() => {
        return editando ? "Detalhes do Usuário" : "Cadastrar Usuário";
    }, [editando]);

    const biggerDevice = useMemo(() => {
        return window.innerWidth > 1590;
    }, []);

    useEffect(() => {
        setValues((current) => ({ ...current, colunas: memoizedMenus }));
    }, [memoizedMenus, profile]);

    useEffect(() => {
        setEditando2(false);
    }, [editando2]);

    const isLoadingRegras = useMemo(() => {
        return loading || !regrasList;
    }, [loading, regrasList]);

    const isLoading = useMemo(() => {
        return !profile?.token || !dadosTabela.length;
    }, [loading, dadosTabela.length, profile?.token]);

    if (semAutorizacao) {
        return <MotionSemAutorizacao />;
    }

    return (
        <Layout key="CadastroUsuario" title={title}>
            <AnimatePresence mode="wait">
                {!telaCadastro ? (
                    <MotionContainer key="telaTabelaCadastroUsuario">
                        <div className="content-container">
                            <Separator size="xl" />
                            <TabelaVirtualizadaGenerica
                                key="TabelaVirtualizadaGenericaCadastroUsuario"
                                colunas={colunasEmpresaInicial.UsuarioGeren}
                                dados={dadosTabela}
                                rowHeight={20}
                                isLoading={isLoading || isLoadingRegras}
                                onRowClick={handleRowClick}
                                getRowClassName={getRowClassName}
                                centralized={biggerDevice}
                                />
                        </div>
                        <div className="footer-space-between">
                            <div>
                                <CustomButtonV2
                                    classCss="custom-button-editar"
                                    classText="button-texto-editar"
                                    titulo="Editar"
                                    icone="iconeEdit"
                                    cor="#CDCDCD"
                                    valor={values}
                                    onClick={() => {
                                        if (tabelaRedux.colunaSelecionada) {
                                            setTelaCadastro(true);
                                            setEditando(true);
                                        } else {
                                            setTextoErro("Selecione Uma Coluna");
                                            setOpenToastErro(true);
                                        }
                                    }}
                                />
                                <CustomButtonV2
                                    classCss="custom-button-deletar"
                                    classText="button-texto-cadastrar"
                                    titulo="Deletar"
                                    icone="iconeDelete"
                                    cor="#DC2D2D"
                                    valor={values}
                                    onClick={() => {
                                        if (tabelaRedux.colunaSelecionada) {
                                            setOpen(true);
                                            setTextoSucesso("Deletado Com Sucesso");
                                        } else {
                                            setTextoErro("Selecione Uma Coluna");
                                            setOpenToastErro(true);
                                        }
                                    }}
                                />
                            </div>
                            <CustomButtonV2
                                classCss="custom-button-user"
                                classText="button-texto-user"
                                titulo="Resetar Senha"
                                width="200px"
                                cor="#FFFFFF"
                                valor={values}
                                onClick={() => {
                                    if (tabelaRedux.colunaSelecionada) {
                                        setOpenResetSenha(true);
                                    } else {
                                        setTextoErro("Selecione Uma Coluna");
                                        setOpenToastErro(true);
                                    }
                                }}
                            />
                        </div>
                    </MotionContainer>
                ) : (
                    <MotionContainer scroll key="telaCadastroCadastroUsuario">
                        <div className="content-container-scrollable">
                            <CadastroEditHeaderProps
                                dadosTitle="Dados de Usuário"
                                headerTitle={detalhesUsuarioString}
                                onClick={handleGoBack}
                            />
                            <Separator size="md" />
                            <div className="cadastrar-usuario-regras">
                                <div
                                    style={{
                                        gap: "10px",
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <div className="rota-div-2" style={{ margin: "0px" }}>
                                        <div className="input-box-container">
                                            <div className="input-container">
                                                <p className="input-label-emb" htmlFor="descricao">
                                                    Nome Usuário:
                                                </p>
                                                <input
                                                    id="nomeUsuario"
                                                    type="text"
                                                    className="input-emb"
                                                    style={{ width: "250px" }}
                                                    onChange={(e) =>
                                                        setValues((current) => ({
                                                            ...current,
                                                            usuario: e.target.value,
                                                        }))
                                                    }
                                                    disabled={true}
                                                    value={values.usuario || ""}
                                                />
                                            </div>
                                        </div>

                                        <div className="input-box-container">
                                            <div className="input-container">
                                                <p className="input-label-emb" htmlFor="descricao">
                                                    E-Mail:
                                                </p>
                                                <input
                                                    disabled
                                                    id="email"
                                                    type="text"
                                                    className="input-emb"
                                                    style={{
                                                        width: "250px",
                                                    }}
                                                    onChange={(e) =>
                                                        setValues((current) => ({
                                                            ...current,
                                                            email: e.target.value,
                                                        }))
                                                    }
                                                    value={values.email || ""}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="rota-div-2">
                                        <div className="input-box-container">
                                            <div className="input-container">
                                                <p className="input-label-emb" htmlFor="descricao">
                                                    Telefone:
                                                </p>
                                                <input
                                                    id="telefone"
                                                    type="text"
                                                    className="input-emb"
                                                    style={{
                                                        width: "250px",
                                                        borderColor:
                                                            validator.telefone === "false" ? "red" : "",
                                                    }}
                                                    onChange={handleChangePhone}
                                                    value={telefoneMask(values.telefone || "")}
                                                />
                                                {validator.telefone === "false" && (
                                                    <div className="error-input-text">
                                                        Telefone invalido.
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="input-box-container">
                                            <div className="input-container">
                                                <p className="input-label-emb" htmlFor="descricao">
                                                    Nascimento:
                                                </p>
                                                <input
                                                    id="nascimento"
                                                    type="date"
                                                    className="input-emb"
                                                    style={{ width: "250px" }}
                                                    onChange={(e) =>
                                                        setValues((current) => ({
                                                            ...current,
                                                            nascimento: e.target.value,
                                                        }))
                                                    }
                                                    value={values.nascimento || ""}
                                                />
                                            </div>
                                        </div>
                                    </div>


                                    <div className="rota-div-2">
                                        <div className="input-box-container">
                                            <div className="input-container">
                                                <p className="input-label-emb" htmlFor="cargo">
                                                    Cargo:
                                                </p>
                                                <input
                                                    id="nomeUsuario"
                                                    type="text"
                                                    className="input-emb"
                                                    style={{ width: "250px" }}
                                                    onChange={(e) =>
                                                        setValues((current) => ({
                                                            ...current,
                                                            cargo: e.target.value,
                                                        }))
                                                    }
                                                    value={values.cargo || ""}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Separator size="2xl" />
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <h3>Permissões:</h3>
                                    <div style={{ marginBottom: "20px" }}>
                                        <p
                                            style={{ textAlign: "center", marginTop: "20px" }}
                                            className="input-label-emb"
                                        >
                                            Clonar permissões do usuário:
                                        </p>
                                        <SelectEmbarqueV2
                                            style={{ marginBottom: "20px" }}
                                            classeCss={250}
                                            onChange={(e) => {
                                                setUsuarioId(e.id);
                                                setValuesSelect((current) => ({
                                                    ...current,
                                                    usuarioIdRegra: e,
                                                }));
                                            }}
                                            value={valuesSelect.usuarioIdRegra}
                                            id="idUsuario"
                                            titulo="Empresa"
                                            dadosSelect={listaUsuarios}
                                            referenciaId="usuario"
                                            referenciaItem="usuario"
                                            info={false}
                                        />
                                    </div>
                                    <Separator size="sm" />
                                    <p>Para atualizar uma permissão, apenas selecione!</p>
                                    <Separator size="md" />
                                    <Box
                                        display="flex"
                                        flexDirection="row"
                                        gap="5px"
                                        alignItems="center"
                                    >
                                        <input
                                            type="checkbox"
                                            checked={allSelected}
                                            onChange={handleSelectAllChange}
                                        />
                                        <strong>Selecionar/Desselecionar Tudo</strong>
                                    </Box>
                                </div>
                                <Separator size="2xl" />
                                <div className="containerPermissaoRegras">
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns:
                                                "repeat(auto-fit, minmax(250px, 5fr))",
                                            gap: "24px",
                                            maxWidth: "100%",
                                        }}
                                    >
                                        {isLoadingRegras && <LoadingComponent />}
                                        {!isLoadingRegras &&
                                            Object.keys(regrasList)?.map((key, index) => (
                                                <div className="usuario-regras-colunm" key={key}>
                                                    <h4>{key}</h4>
                                                    <Separator size="md" />
                                                    <div className="itemRegras">
                                                        {regrasList[key].map((dado, index) => (
                                                            <Box
                                                                display="flex"
                                                                flexDirection="row"
                                                                key={dado.regrasId}
                                                                gap="5px"
                                                            >
                                                                <input
                                                                    type={"checkbox"}
                                                                    checked={dado.check || false}
                                                                    onChange={(e) =>
                                                                        handleCheckboxChange(dado, e)
                                                                    }
                                                                />
                                                                {dado.regra}
                                                            </Box>
                                                        ))}
                                                    </div>
                                                    <Separator size="md" />
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="footer-container">
                            {editando ? (
                                <CustomButtonV2
                                    classCss="custom-button-cadastrar"
                                    classText="button-texto-cadastrar"
                                    icone="iconeSave"
                                    titulo="Salvar"
                                    cor="#0946B8"
                                    valor={values}
                                    onClick={() => {
                                        editar();
                                    }}
                                />
                            ) : (
                                <CustomButtonV2
                                    classCss="custom-button-cadastrar"
                                    classText="button-texto-cadastrar"
                                    icone="iconeSave"
                                    titulo="Salvar"
                                    cor="#0946B8"
                                    valor={values}
                                    onClick={() => {
                                        cadastrar();
                                    }}
                                />
                            )}
                            <CustomButtonV2
                                classCss="custom-button-cancelar"
                                classText="button-texto-cancelar"
                                titulo="Cancelar"
                                cor="#0946B8"
                                valor={values}
                                onClick={handleGoBack}
                            />
                        </div>
                    </MotionContainer>
                )}
            </AnimatePresence>
            <ModalConfirmacao
                titulo="Deletar"
                texto="Deseja Deletar?"
                tituloConfirmar="Confirmar"
                tituloCancelar="Cancelar"
                open={open}
                onClose={handleClose}
                onClick={deletarEmbarcadorPorId}
            />
            <ModalUsuario
                titulo="Usuário"
                tituloConfirmar="OK"
                open={openUsuario}
                onClose={handleCloseUsuario}
            />
            <ModalConfirmacao2
                titulo="Você irá reiniciar a senha desse usuario para: 12345678  Você tem certeza disso?"
                tituloConfirmar="OK"
                textoBotao="Confirmar"
                open={openResetSenha}
                onClose={handleCloseResetSenha}
                onClick={resataSenha}
            />
            <ToastSucesso
                texto={textoSucesso}
                open={openToastSucesso}
                onClose={handleCloseToastSucesso}
            />
            <ToastErro
                texto={textoErro}
                open={openToastErro}
                onClose={handleCloseToastErro}
            />
        </Layout>
    );
}

export default memo(CadastrarUsuario);
